module.exports = __webpack_public_path__ + "img/icon06.e75b0686.svg";